// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"7fe2cced","171":"41438d2e","227":"82f8899d","402":"2d794c5f","453":"2c88876b","648":"53727369","903":"dd06eaa5","923":"e617499a","988":"ed8f7ebe"}[chunkId] + ".chunk.js";
};